import { Toggle } from "@fluentui/react/lib/Toggle";
import { useEditValue } from "../Hooks/UseEditValue";

import { IEditFieldProps } from "../IEditFieldProps";

export function EditBoolean(props: IEditFieldProps): JSX.Element {
  const { htmlId, disabled } = props;
  const { value, onChange } = useEditValue<boolean>(props);
  return <Toggle id={htmlId} checked={value} onChange={onChange} disabled={disabled} />;
}
